import Head from 'next/head';
import { useState, useEffect } from "react";

import Template from "@/widgets/index";
import styles from "./styles.module.css";

import Footer from "@/shared/components/Footer";
import Header from "@/shared/components/Header";
import BannerHorizontalChico from '@/widgets/Banner/Templates/BannerHorizontalChico';
import BannerHorizontalGrande from '@/widgets/Banner/Templates/BannerHorizontalGrande';
import { useAppContext } from '@pagegrowler_nextjs';
import Chartbeat from '@/shared/components/Chartbeat';

function Fotos(props) {
  const LOAD_MORE = 12;

  const { 
    content,		
    pagination = {} 
  } = { ...props };

  let [data, setData] = useState([]);

  const [open, setOpen] = useState(false);
  let [offset, setOffset] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [hideLoadMore, setHideLoadMore] = useState(false);

	const pg = useAppContext();
	const Pagegrowler = pg.pagegrowler;

  let menues = props.menu ? props.menu : [];

  async function showMoreData() {
		setIsLoading(true);
		let res = await Pagegrowler.loadMoreData(LOAD_MORE, offset);
		if (res.content && res.content.length > 0){
      setData(prevState => [...prevState, ...res.content]);
		  setOffset(offset + LOAD_MORE);
		  setIsLoading(false);
    } else {
      setHideLoadMore(true);
    }
	}

  useEffect(() => {
		setOffset(pagination.limit + pagination.offset);
		setData(content);
	}, []);
  let dataLDJson =  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Diario El Litoral",
    "url": "https://www.ellitoral.com",
    "logo": {
      "@type": "ImageObject",
      "url": `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/header_logoellitoral.svg`,
      "width": 439,
      "height": 60
    },
    "sameAs": ["https://www.facebook.com/ellitoralcom", "https://instagram.com/ellitoral", "https://twitter.com/ellitoral", "https://plus.google.com/+EllitoralArgentina"]
  };
  const titleLinks = [
    { text: "Galerías", url: "/fotos-hd" },
    { text: "Videos", url: "/videos" },
    { text: "CYD LITORAL", url: "https://www.ellitoral.com/um/cydlitoral-envivo-cableydiario" },
  ];

  return (
    <>
      <Head>
        <title>Galerías - El Litoral</title>
        <meta name="description" property="description" content="Galerías - El Litoral. Noticias actualizadas las 24 horas." />
        <meta name="og:image" property="og:image" content={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
        <link rel="image_src" href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(dataLDJson) }} />  
        <meta httpEquiv="refresh" content="600" />
        <link rel="canonical" href={process.env.NEXT_PUBLIC_DOMAIN_URL + "/fotos-hd"} />
        <meta name="robots" content="max-image-preview:large" />
      </Head>
      <Chartbeat />
      <Header menues={menues} isOpenSidePanel={(open) => setOpen(open)} />
      <div className={`${styles["parent"]}`}>
        <div className={styles["container"]}>
         
          <div className={styles["title-container"]}>
            <div className={styles["title"]}>
              <h1 className={styles["title-text"]}>Multimedia</h1>
              <ul className={styles["title-links"]}>
                {titleLinks.map(({ text, url }) => (
                  <li key={text}>
                    <a href={url}>{text}</a>
                  </li>
                ))}
              </ul>
            </div>
            <hr className={styles["line"]} />
          </div>

          <div className={styles["subtitle"]}>
            <h2 className={styles["subtitle-text"]}>Galerías</h2>
            <hr className={styles["subtitle-line"]} />
          </div>

          { data && (
            <Template.Multimedia content={data} />
          )}

          <div className={styles["btn-container"]}>
            <button className={`${styles["btn"]} ${styles[hideLoadMore? 'hide': '']}`} disabled={isLoading} onClick={showMoreData}>
              Cargar más galerías
            </button>
          </div>
          {!props.preview && <BannerHorizontalChico bannerId={'horizontal1'}/>}
        </div>
      </div>
      <div style={{ clear: "both" }}>
        <Footer />
      </div>
    </>
  );
}

export default Fotos;
